
// ==============================
// DISABLE ZOOM OF INPUT FIELD ON iOS
// ==============================
(function () {
	const ua = navigator.userAgent.toLowerCase();
	const isiOS = ua.includes('iphone') || ua.includes('ipad');
	if (!isiOS) return;

	const viewport = document.querySelector('meta[name="viewport"]');
	if (!viewport) return;

	const content = viewport.getAttribute('content') || '';
	if (!/user-scalable\s*=/.test(content)) {
		viewport.setAttribute('content', content + (content ? ', ' : '') + 'user-scalable=no');
	}
})();

// ==============================
// SMOOTH SCROLL
// ==============================
(function () {
	const header = document.querySelector('header');
	const headH = header ? header.offsetHeight : 0;

	const smoothScroll = (target, offset) => {
		let toY;
		let nowY = window.pageYOffset;
		const divisor = 8;
		const range = (divisor / 2) + 1;

		const targetRect = target.getBoundingClientRect();
		const targetY = targetRect.top + nowY - offset - 65;

		(function step() {
			toY = nowY + Math.round((targetY - nowY) / divisor);
			window.scrollTo(0, toY);
			nowY = toY;

			if (document.body.clientHeight - window.innerHeight < toY) {
				window.scrollTo(0, document.body.clientHeight);
				return;
			}
			if (toY >= targetY + range || toY <= targetY - range) {
				window.setTimeout(step, 10);
			} else {
				window.scrollTo(0, targetY);
			}
		})();
	};

	const smoothOffset = headH;
	const links = document.querySelectorAll('a[href*="#"]');

	links.forEach(function (link) {
		link.addEventListener('click', function (e) {
			const href = link.getAttribute('href') || '';
			if (!href.includes('#')) return;

			const hash = href.split('#')[1];
			if (!hash) return;

			const target = document.getElementById(hash);
			if (!target) return;

			e.preventDefault();
			smoothScroll(target, smoothOffset);
		});
	});
})();

// ==============================
// BREADCRUMB LIST REORDER
// ==============================
window.addEventListener('load', function() {
	const breadcrumbItems = document.querySelectorAll('.breadcrumb__list li');
	breadcrumbItems.forEach(function(item) {
		const parent = item.parentNode;
		if (parent) {
			parent.appendChild(item);
		}
	});
});
